var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapRefreshIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8318 13.0079C15.2439 17.2248 10.697 19.2963 6.67266 17.6357C2.6515 15.9717 0.674657 11.2072 2.25944 6.99018C3.84487 2.77653 8.39111 0.701718 12.4154 2.36637C13.6833 2.88724 14.7958 3.74691 15.6474 4.86068L13.6209 6.98418C13.5553 7.0522 13.5553 7.16625 13.6209 7.23828C13.6553 7.27095 13.6986 7.2903 13.7425 7.2903H18.7177C18.8106 7.28696 18.8889 7.20893 18.8889 7.10822V1.89685C18.8889 1.79548 18.8112 1.71745 18.7177 1.71745C18.6712 1.71745 18.6273 1.73679 18.5968 1.76947L16.8624 3.58351C13.4815 -0.652812 7.46506 -1.21303 3.42226 2.33036C-0.621177 5.87307 -1.15899 12.1775 2.22253 16.4145C5.60404 20.6509 11.6231 21.2144 15.6665 17.671C16.891 16.5966 17.8387 15.2221 18.423 13.6655L16.8318 13.0079Z",
    fill: "#061A42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapRefreshIcon);
export default __webpack_public_path__ + "static/media/mapRefreshIcon.6a0762306ede9526b456926755ff0edf.svg";
export { ForwardRef as ReactComponent };